import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const RoleService = {
  RoleList,
  RoleByID,
  createRole,
  updateRole,
  deleteRole,
};

async function RoleList(filter) {
  let url = "/user-management/roles?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
}

async function RoleByID(id) {
  try {
    const response = await RestMethod.GET("/user-management/roles/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function createRole(data) {
  try {
    const response = await RestMethod.POST("/user-management/roles", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateRole(id, data) {
  try {
    const response = await RestMethod.PUT("/user-management/roles/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function deleteRole(id) {
  try {
    const response = await RestMethod.DELETE("/user-management/roles/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
